import React from "react";

const DropUpArrow = ({ color = "#000000", size = "10" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7L7 1L1 7"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DropUpArrow;
